import Navbar from "../../../components/Navbar/Navbar";
import ProviderSessionActivityWrapper from "../components/ProviderSessionActivityWrapper/ProviderSessionActivityWrapper";

export default function ProviderSessionActivityPage() {
    return (
        <>
            <Navbar title="Provider Session Activity" />
            <div className="page">
                <ProviderSessionActivityWrapper />
            </div>
        </>
    );
}
